import { AfterViewInit, Directive, ElementRef, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import ClipboardJS from 'clipboard';

import { ToastService } from '@mode/shared/util-toast';

@Directive({
  standalone: true,
  selector: '[modeClipboard]',
})
export class ClipboardDirective implements AfterViewInit, OnDestroy {
  @Input() clipboardText = '';
  @Input() successToastMessage = 'Copied to clipboard';
  @Output() clipboardSuccess = new EventEmitter<void>();
  @Output() clipboardError = new EventEmitter<void>();
  private _clipboard: ClipboardJS | undefined;

  constructor(
    private _hostElement: ElementRef,
    private _toastService: ToastService
  ) {}

  public ngAfterViewInit(): void {
    this._clipboard = new ClipboardJS(this._hostElement.nativeElement, {
      text: () => this.clipboardText,
    });

    this._clipboard.on('success', () => {
      this._toastService.success(this.successToastMessage || 'Copied to clipboard');
      this.clipboardSuccess.emit();
    });

    this._clipboard.on('error', () => {
      this._toastService.error('Copy and paste failed');
      this.clipboardError.emit();
    });
  }

  public ngOnDestroy(): void {
    if (this._clipboard) {
      this._clipboard.destroy();
    }
  }
}
